import { TICKER_ITEMS, num } from "../terminalMock";

/** The list is rendered twice so the -50% marquee loop is seamless. */
const MARQUEE_ITEMS = [...TICKER_ITEMS, ...TICKER_ITEMS];

export function TickerStrip() {
  return (
    <div
      className="overflow-hidden border-b py-8"
      style={{ background: "var(--t-panel)", borderColor: "var(--t-line)" }}
    >
      <div className="t-anim-marquee flex w-max gap-34">
        {MARQUEE_ITEMS.map((item, index) => (
          <div key={`${item.sym}-${index}`} className="flex items-baseline gap-8 whitespace-nowrap text-[12.5px]">
            <span className="font-semibold tracking-[0.4px]" style={{ color: "var(--t-deep)" }}>
              {item.sym}
            </span>
            <span className="t-nums" style={{ color: "var(--t-tx)" }}>
              ${num(item.px, item.px < 10 ? 4 : 2)}
            </span>
            <span className="t-nums font-semibold" style={{ color: item.up ? "var(--t-long)" : "var(--t-short)" }}>
              {item.up ? "+" : "-"}
              {item.chg.toFixed(2)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
